import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { BaseWrapper } from "./app/component/BaseWrapper";
import { CriticalInitializationErrorNotification } from "./app/component/CriticalInitializationErrorNotification";
import { assertNonNullable } from "./app/utils/assert";
import { DEFAULT_LOCALE } from "./config/locale";
import { logger } from "./config/logging";
import lazyLoadedFramePromise from "./initialization";

const container = document.getElementById("root");
assertNonNullable(container);
// https://martijnhols.nl/blog/everything-about-google-translate-crashing-react
container.setAttribute("notranslate", "true");
const root = createRoot(container);

lazyLoadedFramePromise
	.then(({ node: children }) => {
		root.render(<StrictMode>{children}</StrictMode>);
	})
	.catch(x => {
		logger.error(x);
		root.render(
			<StrictMode>
				<BaseWrapper locale={DEFAULT_LOCALE}>
					<CriticalInitializationErrorNotification />
				</BaseWrapper>
			</StrictMode>
		);
	});
